import { toast } from "sonner";

const proximamente = (etiqueta) =>
  toast(`Reservas ${etiqueta}`, {
    description:
      "Muy pronto podrás reservar en línea con integración de calendario y WhatsApp. Por ahora escríbenos y agendamos tu experiencia.",
    duration: 5000,
  });

// Funciones placeholder para el futuro backend (citas, CRM, fidelización,
// integración con calendarios y WhatsApp).
export const reservarElla = () => {
  window.dispatchEvent(new CustomEvent("open-booking", { detail: { category: "ella" } }));
};

export const reservarEl = () => {
  window.dispatchEvent(new CustomEvent("open-booking", { detail: { category: "el" } }));
};

export const reservarDuo = () => {
  window.dispatchEvent(new CustomEvent("open-booking", { detail: { category: "duo" } }));
};

export const reservarServicio = (categoria, nombreServicio) => {
  window.dispatchEvent(new CustomEvent("open-booking", { detail: { category: categoria, serviceName: nombreServicio } }));
};

// Exponer en window para pruebas / futura integración.
if (typeof window !== "undefined") {
  window.reservarElla = reservarElla;
  window.reservarEl = reservarEl;
  window.reservarDuo = reservarDuo;
  window.reservarServicio = reservarServicio;
}

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const scrollToTop = () => {
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(0, { duration: 1.3 });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
